export enum AdImpressionsValueType {
  Default,
  Range,
}
